import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  selector: 'qb-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [RouterLink],
})
export class HomeComponent {
  constructor() {}

  signUp() {
    const url = `https://${environment.auth0Domain}/authorize?prompt=login&response_type=code&client_id=${environment.auth0ClientId}&redirect_uri=${environment.auth0CallbackUrl}&screen_hint=signup`;
    window.location.href = url;
  }
}
